import clsx from 'clsx'
import { type PropsWithChildren } from 'react'

import { type Period, type RenewalApproach } from 'apps/employer_renewals/types'
import { useBreakpoint } from 'slab'

import EmployeeFilterSelect from './EmployeeFilterSelect'
import PeriodToggle from './PeriodToggle'
import RenewalCosts, { type RenewalCostsProps } from './RenewalCosts'
import Card from '../card/Card'

type Props = {
  renewalApproach: RenewalApproach
  onPeriodChange: (period: Period) => void
} & RenewalCostsProps

export default function CostsCard ({
  renewalApproach,
  period,
  currentYearCost,
  renewalYearCost,
  qmeEnabled,
  isLoading,
  onPeriodChange,
  children,
}: PropsWithChildren<Props>) {
  const { breakpointIsAtLeast } = useBreakpoint()

  return (
    <Card raw>
      <div className={clsx('flex flex-row gap-2 items-center px-6 py-3 flex-wrap-reverse', {
        'justify-center': !breakpointIsAtLeast('xs'),
        'justify-between': breakpointIsAtLeast('xs'),
      })}
      >
        <EmployeeFilterSelect />
        <PeriodToggle period={period} onPeriodChange={onPeriodChange} />
      </div>
      <div className='px-6'>
        <RenewalCosts
          currentYearCost={currentYearCost}
          renewalYearCost={renewalYearCost}
          renewalApproach={renewalApproach}
          period={period}
          qmeEnabled={qmeEnabled}
          isLoading={isLoading}
        />
      </div>
      {children}
    </Card>
  )
}
